module.exports = __webpack_public_path__ + "media/images/official/contract_form_done_2-fd7fd42bd6dad811791322cd7f0b8669.png";